const DEFAULT_LOCALE = 'en-US'
const DEFAULT_CURRENCY = 'USD'

const currencyFormatters = new Map<string, Intl.NumberFormat>()

function currencyFormatter(currency: string) {
  let formatter = currencyFormatters.get(currency)
  if (!formatter) {
    formatter = new Intl.NumberFormat(DEFAULT_LOCALE, {
      style: 'currency',
      currency,
      maximumFractionDigits: 0,
    })
    currencyFormatters.set(currency, formatter)
  }
  return formatter
}

export function formatCurrency(value: number, currency = DEFAULT_CURRENCY) {
  return currencyFormatter(currency).format(value)
}

const shortDate = new Intl.DateTimeFormat(DEFAULT_LOCALE, {
  dateStyle: 'medium',
})
export function formatDate(value: string | number | Date) {
  return shortDate.format(new Date(value))
}

const dateTime = new Intl.DateTimeFormat(DEFAULT_LOCALE, {
  dateStyle: 'medium',
  timeStyle: 'short',
})
export function formatDateTime(value: string | number | Date) {
  return dateTime.format(new Date(value))
}

const relative = new Intl.RelativeTimeFormat(DEFAULT_LOCALE, { numeric: 'auto' })
const DIVISIONS: { amount: number; unit: Intl.RelativeTimeFormatUnit }[] = [
  { amount: 60, unit: 'second' },
  { amount: 60, unit: 'minute' },
  { amount: 24, unit: 'hour' },
  { amount: 7, unit: 'day' },
  { amount: 4.34524, unit: 'week' },
  { amount: 12, unit: 'month' },
  { amount: Number.POSITIVE_INFINITY, unit: 'year' },
]

export function formatRelativeTime(value: string | number | Date) {
  let duration = (new Date(value).getTime() - Date.now()) / 1000
  for (const division of DIVISIONS) {
    if (Math.abs(duration) < division.amount) {
      return relative.format(Math.round(duration), division.unit)
    }
    duration /= division.amount
  }
  return shortDate.format(new Date(value))
}

export function initials(name: string) {
  return name
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? '')
    .join('')
}
